<template>
    <section class="consultation-wrapper">
        <div v-if="coach" class="consultation-coach">
            <figure>
                <img :src="coach.user.avatar" alt="" />
            </figure>

            <div class="coach-info">
                <span v-if="coach.user.sex === 'm'">{{ __("[f] Personal dietitian") }}</span>
                <span v-else>{{ __("[m] Personal dietitian") }}</span>
                <strong>{{ coach.user | fullname }}</strong>
                <span class="tag-verified">
                    <svg width="23px" height="22px" viewBox="0 0 23 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="1_onboarding-2-copy" transform="translate(-193.000000, -105.000000)">
                                <g id="Group" transform="translate(194.000000, 106.000000)">
                                    <path id="Path" d="M20.3574462,9.05344161 L18.5875852,7.22424298 L18.9440948,4.70445762 C19.0360768,4.05445633 18.5958318,3.44821126 17.9484687,3.33469889 L15.4411655,2.89491753 L14.2479366,0.64718152 C13.9399554,0.0669364597 13.2272533,-0.16452736 12.6372996,0.124009821 L10.3501189,1.24137775 L8.06325549,0.124009821 C7.47298456,-0.16452736 6.76028243,0.0669364597 6.45230129,0.64718152 L5.25938958,2.89491753 L2.7517692,3.33469889 C2.10472322,3.44821126 1.66416105,4.05413928 1.75614304,4.70445762 L2.11296992,7.22424298 L0.342791623,9.05312455 C-0.114263874,9.52524739 -0.114263874,10.2744928 0.342791623,10.7462985 L2.11296992,12.5754972 L1.75614304,15.0949655 C1.66416105,15.7452837 2.10472322,16.3515288 2.7517692,16.4647242 L5.25938958,16.9045055 L6.45230129,19.1525586 C6.67052072,19.5638033 7.09205212,19.7997062 7.5291253,19.7997062 C7.70896604,19.7997062 7.89134422,19.7597549 8.06325549,19.6757303 L10.3501189,18.5583623 L12.6369824,19.6760475 C13.2275705,19.9645846 13.9402726,19.7328036 14.2479366,19.1528757 L15.4411655,16.9048225 L17.9484687,16.4650413 C18.5958318,16.3515288 19.0360768,15.7456008 18.9440948,15.0952825 L18.5875852,12.5754972 L20.3574462,10.7466156 C20.8141846,10.2744928 20.8141846,9.52524739 20.3574462,9.05344161 L20.3574462,9.05344161 Z" stroke="#F7F7F9" stroke-width="0.99" fill="#00A671" fill-rule="nonzero"></path>
                                    <path id="Path" d="M15.1550269,7.80684527 C15.3483244,7.61832649 15.3483244,7.31264727 15.1550269,7.12412849 L14.4550041,6.44141171 C14.2617066,6.25286276 13.9482788,6.25286276 13.7549503,6.44141171 L9.1125,10.9690607 L6.94504969,8.85519433 C6.75175219,8.66667555 6.43832438,8.66667555 6.24499594,8.85519433 L5.54497313,9.53791111 C5.35167563,9.72642989 5.35167563,10.0321091 5.54497313,10.2206279 L8.76247313,13.3585845 C8.95580156,13.5471335 9.26919844,13.5471335 9.46252688,13.3586147 L15.1550269,7.80684527 Z" fill="#FFFFFF"></path>
                                </g>
                            </g>
                        </g>
                    </svg>
                </span>
            </div>
        </div>

        <div v-else>
            <strong class="h2">{{ __("Choose the date of your first consultation") }}</strong>
            <p v-if="coach.user.sex === 'm'">{{ __("[f] After booking a phone consultation, we will put you in touch with your dietitian.") }}</p>
            <p v-else>{{ __("[m] After booking a phone consultation, we will put you in touch with your dietitian.") }}</p>  
        </div>

        <form>
            <span class="datepicker-wrapper">
                <input id="date-input" class="datepicker" name="date" :placeholder="__('Select the date')" readonly />
            </span>

            <template v-if="errors.date">
                <span class="help-block">
                    <strong>{{ errors.date[0] }}</strong>
                </span>
            </template>
        </form>

        <form id="consultation-form" @submit.prevent="submit">
            <select id="available-times" :disabled="!date" class="selectpicker" name="time" @change="onTimeSelect">
                <option>{{ __("Select the time") }}</option>

                <option v-for="(times, i) in timeslots" :key="i">
                    {{ times }}
                </option>
            </select>

            <template v-if="errors.slots">
                <span class="help-block">
                    <strong>{{ errors.slots[0] }}</strong>
                </span>
            </template>

            <input id="date-hidden-input" name="date" type="hidden" />
            <button
                :class="{ 'opacity': !canSubmitReservation }"
                :disabled="!canSubmitReservation"
                class="btn btn-default btn-lg btn-wide"
                type="submit"
            >
                <span>{{ __("Book a date") }}</span>
            </button>
        </form>
    </section>
</template>

<script>
export default {
    props: {
        coach: {
            type: Object,
            required: false,
            default: null
        }
    },
    data() {
        return {
            timeslots: null,
            date: null,
            interval: null,
            errors: {}
        }
    },
    computed: {
        canSubmitReservation() {
            return this.date && this.interval
        }
    },
    async mounted() {
        const datesDisabled = await this.fetchDisabledDates()

        $(() => {
            $('select').selectpicker({})

            $('.datepicker').datepicker({
                language: _.get(window, 'locale', 'cs'),
                startDate: '+3d',
                endDate: '+3w',
                autoclose: true,
                format: 'd. m. yyyy',
                datesDisabled: datesDisabled.map(d => moment(d, 'DD/MM/YYYY').format('DD.MM.YYYY'))
            })

            $('.datepicker').on('changeDate', this.onDatechange)
        })
    },
    methods: {
        fetchDisabledDates() {
            return axios.get('/api/consultation/unavailable_dates').thenData()
        },
        fetchAvailableTimes(date) {
            return axios.get(`/api/consultation/times/${date}`).thenData()
        },
        async onDatechange() {
            this.date = moment($('.datepicker').val(), 'D. M. YYYY').format('YYYY-MM-DD')

            this.timeslots = await this.fetchAvailableTimes(this.date)

            console.log(this.timeslots)

            // wait for vue
            this.$nextTick(() => {
                $('#available-times').val(null)
                $('#available-times').selectpicker('refresh')
            })
        },
        onTimeSelect() {
            this.interval = $('#available-times').val()
        },
        async submit() {
            $(this.$el)
                .find('button[type=submit]')
                .addClass('btn-disabled')
                .find('span')
                .text(lang.get('Sending'))

            axios
                .post('/api/consultation', {
                    date: this.date,
                    interval: this.interval
                })
                .then(({ data }) => {
                    if (data.consultation) {
                        window.location.href = `/konzultace-naplanovana/${data.consultation.id}`
                    }
                })
                .catch((e) => {
                    $(this.$el)
                        .find('button[type=submit]')
                        .removeClass('btn-disabled')
                        .find('span')
                        .text(lang.get('Book a date'))

                    this.errors = e.response.data.errors
                })
        }
    }
}
</script>
